<template>
  <div class="bid-records">
    <div class="page-header">
      <h2>投标记录</h2>
      <p>查看投标记录信息</p>
    </div>
    
    <div class="page-content">
      <!-- 筛选条件 -->
      <el-form :inline="true" style="margin-bottom: 20px;">
        <el-form-item label="选择项目：">
          <el-input
            v-model="selectedProjectName"
            placeholder="请选择项目"
            readonly
            @click="openProjectDialog"
            style="width: 200px;">
            <el-button slot="append" icon="el-icon-search" @click="openProjectDialog"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="选择包：">
          <el-input
            v-model="selectedPackageName"
            placeholder="请选择包"
            readonly
            @click="openPackageDialog"
            style="width: 200px;">
            <el-button slot="append" icon="el-icon-search" @click="openPackageDialog"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="选择投标人：">
          <el-input
            v-model="selectedBidderName"
            placeholder="请选择投标人"
            readonly
            @click="openBidderDialog"
            style="width: 200px;">
            <el-button slot="append" icon="el-icon-search" @click="openBidderDialog"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData">查询</el-button>
          <el-button type="success" @click="exportCsv">导出Excel</el-button>
          <el-button @click="clearFilters">清空筛选</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 投标记录表格（树形结构） -->
      <el-table
        :data="treeData"
        v-loading="loading"
        row-key="rowKey"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :default-expand-all="true"
        @sort-change="onSortChange"
        style="width: 100%">
        <el-table-column prop="name" label="名称/信息" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.is_main_package" style="font-weight: bold; color: #409EFF;">
              📦 {{ scope.row.package_name }}
            </span>
            <span v-else-if="scope.row.is_sub_package" style="font-weight: bold; color: #67C23A;">
              📋 {{ scope.row.sub_package_name }} ({{ scope.row.sub_package_no }})
            </span>
            <span v-else>
              👤 {{ scope.row.bidder_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sub_package_no" label="分包编号" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.is_sub_package">{{ scope.row.sub_package_no }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="采购数量" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.is_sub_package">{{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="all_average_price" label="所有均价" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_sub_package && scope.row.all_average_price !== undefined">
              ¥{{ Number(scope.row.all_average_price).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="valid_average_price" label="有效均价" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_sub_package && scope.row.valid_average_price !== undefined">
              ¥{{ Number(scope.row.valid_average_price).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="base_price" label="基准价" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_sub_package && scope.row.base_price !== undefined">
              ¥{{ Number(scope.row.base_price).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="serial_no" label="序号" width="80" sortable="custom">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_main_package && !scope.row.is_sub_package">
              {{ scope.row.serial_no }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="bid_price" label="投标价格" width="120" sortable="custom">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_main_package && !scope.row.is_sub_package">
              ¥{{ scope.row.bid_price.toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="unit_price" label="单价" width="120" sortable="custom">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_main_package && !scope.row.is_sub_package">
              ¥{{ scope.row.unit_price.toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="reasonable_price" label="合理价格" width="120">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_main_package && !scope.row.is_sub_package">
              ¥{{ scope.row.reasonable_price.toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="price_score" label="价格分" width="100" sortable="custom">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_main_package && !scope.row.is_sub_package">
              {{ scope.row.price_score.toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_main_package && !scope.row.is_sub_package">
              {{ scope.row.created_at }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      
      <div style="margin-top: 20px; text-align: center;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="bidRecordsTotal"
          layout="prev, pager, next, total">
        </el-pagination>
      </div>
    </div>
    
    <!-- 项目选择弹窗 -->
    <ProjectSelectDialog
      :visible.sync="showProjectDialog"
      @select="selectProject" />
    
    <!-- 包选择弹窗 -->
    <PackageSelectDialog
      :visible.sync="showPackageDialog"
      @select="selectPackage" />
    
    <!-- 投标人选择弹窗 -->
    <BidderSelectDialog
      :visible.sync="showBidderDialog"
      @select="selectBidder" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProjectSelectDialog from '../components/ProjectSelectDialog.vue'
import PackageSelectDialog from '../components/PackageSelectDialog.vue'
import BidderSelectDialog from '../components/BidderSelectDialog.vue'

export default {
  name: 'BidRecords',
  components: {
    ProjectSelectDialog,
    PackageSelectDialog,
    BidderSelectDialog
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      sortBy: '',
      sortDir: '',
      
      // 选择状态
      selectedProjectId: null,
      selectedPackageIds: [],
      selectedSubPackageIds: [],
      selectedBidderId: null,
      selectedProjectName: '',
      selectedPackageName: '',
      selectedBidderName: '',
      
      // 弹窗控制
      showProjectDialog: false,
      showPackageDialog: false,
      showBidderDialog: false
    }
  },
  computed: {
    ...mapState(['bidRecords', 'bidRecordsTotal']),
    
    // 将后端返回的树形数据转换为前端需要的格式
    treeData() {
      if (!this.bidRecords || this.bidRecords.length === 0) {
        return []
      }
      
      const result = []
      
      this.bidRecords.forEach(pkg => {
        // 主包节点
        const mainPackageNode = {
          rowKey: pkg.row_key,
          is_main_package: true,
          package_name: pkg.package_name,
          unit_name: pkg.unit_name,
          percentage: pkg.percentage,
          children: []
        }
        
        // 处理分包节点
        if (pkg.children && pkg.children.length > 0) {
          pkg.children.forEach(subPkg => {
            // 分包节点
            const subPackageNode = {
              rowKey: subPkg.row_key,
              is_sub_package: true,
              sub_package_name: subPkg.sub_package_name,
              sub_package_no: subPkg.sub_package_no,
              quantity: subPkg.quantity,
              all_average_price: subPkg.all_average_price,
              valid_average_price: subPkg.valid_average_price,
              base_price: subPkg.base_price,
              children: []
            }
            
            // 处理投标记录
            if (subPkg.children && subPkg.children.length > 0) {
              subPkg.children.forEach(record => {
                subPackageNode.children.push({
                  rowKey: `bidrecord_${record.id}`,
                  is_main_package: false,
                  is_sub_package: false,
                  ...record
                })
              })
            }
            
            mainPackageNode.children.push(subPackageNode)
          })
        }
        
        result.push(mainPackageNode)
      })
      
      return result
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions(['loadBidRecords']),
    
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          sort_by: this.sortBy,
          sort_dir: this.sortDir
        }
        if (this.selectedPackageIds.length > 0) {
          params.package_ids = this.selectedPackageIds.join(',')
        }
        if (this.selectedSubPackageIds.length > 0) {
          params.sub_package_ids = this.selectedSubPackageIds.join(',')
        }
        if (this.selectedBidderId) {
          params.bidder_id = this.selectedBidderId
        }
        await this.loadBidRecords(params)
      } finally {
        this.loading = false
      }
    },
    
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadData()
    },
    
    // 弹窗相关方法
    openProjectDialog() {
      this.showProjectDialog = true
    },
    
    openPackageDialog() {
      this.showPackageDialog = true
    },
    
    openBidderDialog() {
      this.showBidderDialog = true
    },
    
    selectProject(project) {
      this.selectedProjectId = project.id
      this.selectedProjectName = project.unit_name
      this.selectedPackageIds = []
      this.selectedSubPackageIds = []
      this.selectedPackageName = ''
      this.currentPage = 1
      this.loadData()
    },
    
    selectPackage(selection) {
      this.selectedPackageIds = selection.packageIds || []
      this.selectedSubPackageIds = selection.subPackageIds || []
      
      // 生成显示名称
      const names = []
      if (selection.selectedRows) {
        selection.selectedRows.forEach(row => {
          if (row.isMainPackage) {
            names.push(row.package_name)
          } else {
            names.push(`${row.sub_package_name}(${row.sub_package_no})`)
          }
        })
      }
      this.selectedPackageName = names.length > 0 ? names.join('、') : ''
      
      this.currentPage = 1
      this.loadData()
    },
    
    selectBidder(bidder) {
      this.selectedBidderId = bidder.id
      this.selectedBidderName = bidder.name
      this.currentPage = 1
      this.loadData()
    },
    
    clearFilters() {
      this.selectedProjectId = null
      this.selectedPackageIds = []
      this.selectedSubPackageIds = []
      this.selectedBidderId = null
      this.selectedProjectName = ''
      this.selectedPackageName = ''
      this.selectedBidderName = ''
      this.currentPage = 1
      this.loadData()
    },
    onSortChange({ prop, order }) {
      this.sortBy = prop || ''
      this.sortDir = order === 'descending' ? 'DESC' : (order === 'ascending' ? 'ASC' : '')
      this.currentPage = 1
      this.loadData()
    },
    exportCsv() {
      const params = new URLSearchParams()
      if (this.selectedPackageIds.length > 0) params.append('package_ids', this.selectedPackageIds.join(','))
      if (this.selectedSubPackageIds.length > 0) params.append('sub_package_ids', this.selectedSubPackageIds.join(','))
      if (this.selectedBidderId) params.append('bidder_id', this.selectedBidderId)
      if (this.sortBy) params.append('sort_by', this.sortBy)
      if (this.sortDir) params.append('sort_dir', this.sortDir)
      const url = `/import/bid-records/export?${params.toString()}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
}

.page-header p {
  margin: 0;
  color: #909399;
}
</style>
